export const getFileAsDataUrlWithName = (file: File) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  return new Promise((resolve, reject) => {
    reader.addEventListener('load', () => {
      if (typeof reader.result === 'string') {
        return resolve(addNameToDataURL(reader.result, file?.name));
      }
      return resolve(reader.result);
    });

    // eslint-disable-next-line unicorn/prefer-add-event-listener
    reader.onerror = (error) => reject(error);
  });
};

const addNameToDataURL = (dataURL?: string, name?: string) => {
  if (!dataURL) {
    return;
  }
  if (!name) {
    return dataURL;
  }
  return dataURL.replace(';base64', `;name=${encodeURIComponent(name)};base64`);
};
